import { render, staticRenderFns } from "./ChurchPlanting.vue?vue&type=template&id=2e8b8d1e&scoped=true"
import script from "./ChurchPlanting.vue?vue&type=script&lang=js"
export * from "./ChurchPlanting.vue?vue&type=script&lang=js"
import style0 from "./ChurchPlanting.vue?vue&type=style&index=0&id=2e8b8d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b8d1e",
  null
  
)

export default component.exports